/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_Th3Inputs */

const en_mk_cmp_linear_th3 = /** @type {(inputs: Mk_Cmp_Linear_Th3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents come from third parties an admin has to install.`)
};

const id_mk_cmp_linear_th3 = /** @type {(inputs: Mk_Cmp_Linear_Th3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen datang dari pihak ketiga yang harus dipasang admin.`)
};

/**
* | output |
* | --- |
* | "Agents come from third parties an admin has to install." |
*
* @param {Mk_Cmp_Linear_Th3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_th3 = /** @type {((inputs?: Mk_Cmp_Linear_Th3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_Th3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_th3(inputs)
	return en_mk_cmp_linear_th3(inputs)
});